import request from '@/utils/request'
const server = "/cloudhealth-server-portal"

export function createNewFollowUp(query) {
  return request({
    url: server+'/healthinfo/followup/addFollowUp',
    method: 'post',
    data: query
  })
}

export function updateFollowup(query) {
  return request({
    url: server+'/healthinfo/followup/updateFollowup',
    method: 'post',
    data: query
  })
}

export function getFollowUpList(startTime, endTime, patientId, status, pageNum, pageSize) {
  return request({
    url: server+'/healthinfo/followup/listFollowUp',
    method: 'get',
    params: {startTime:startTime, endTime:endTime, patientId: patientId, status:status,
            pageNum: pageNum, pageSize: pageSize}
  })
}

export function deleteFollowUp(reqParam) {
  return request({
    url: server+'/healthinfo/followup/deleteFollowUp',
    method: 'post',
    data: reqParam
  })
}

export function stopFollowUpPlan(id) {
  return request({
    url: server+'/healthinfo/followup/deleteFollowUpPlan',
    method: 'post',
    params: {id:id}
  })
}

export function getFollowUpDetail(id) {
  return request({
    url: server+'/healthinfo/followup/getFollowUpById',
    method: 'get',
    params: {followupId: id}
  })
}

//获取问卷
export function getQuestionnaire(voteId) {
  return request({
    url: server+'/healthinfo/vote/getVoteDetail',
    method: 'get',
    params: {voteId: voteId}
  })
}

//提交问卷答案
export function uploadVoteAnswer(query) {
  return request({
    url: server+'/healthinfo/vote/addVoteAnswerForFollowup',
    method: 'post',
    params: query
  })
}

// 获取问卷答案
export function requestVoteAnswer(recordId) {
  return request({
    url: server+'/healthinfo/vote/getVoteAnswer',
    method: 'post',
    params: {recordId:recordId}
  })
}

export function getFollowupQuestionaire() {
  return request({
    url: server+'/healthinfo/followup/getFollowupVotes',
    method: 'get',
    params: {}
  })
}

// 获取随访监测数据
export function getFollowupMeasureData(patientId,followUpId,followUpDate) {
  return request({
    url: server+'/healthinfo/followup/getFollowupMeasureData',
    method: 'get',
    params: {patientId:patientId,followUpId:followUpId,followUpDate:followUpDate}
  })
}
